import { Component, computed, inject } from "@angular/core";
import { UserStoreService } from "@cq/app/core/user/stores/user-store.service";
import { IconModule } from "@cq/app/shared/icon/icon.module";

@Component({
  selector: "cq-logout",
  standalone: true,
  imports: [IconModule],
  templateUrl: "./logout.component.html",
  styleUrl: "./logout.component.scss",
})
export class LogoutComponent {
  #user = inject(UserStoreService);

  copyrightYear = new Date().getFullYear();
  helpDeskNumber = computed(() => this.#user.current().helpDeskNumber);
}
